var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 20,
    viewBox: "0 0 85 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.182619 20L6.40024 10L0.182617 0L84.4002 3.68127e-06V20L0.182619 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40039 19L7.47652 9.9994L1.4012 1L83.6955 1V19L1.40039 19Z",
    fill: "#0553A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentPlan);
export default __webpack_public_path__ + "static/media/currentPlan.101207b39db64b4536b084b39b98684a.svg";
export { ForwardRef as ReactComponent };